import React, {useState} from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/me.png'
import HeaderSocial from './HeaderSocial'
import TypeAnimation from 'react-type-animation';



const Header = ({text1,text2,text3,img}) => {
    const[ctarequired,setctarequired]=useState(true)
  return (
    <header style={{ backgroundImage: `url(${img})` }}>
        {/*<img className='img-bg' src={Background} alt="background"/>*/}
        <div className="container header__container">
            {/* <div className='imgbg'>
                <img src={Background} alt="background"/>
             </div> */}
            <h3>
                {text1}
            </h3>

            <h1>
            <TypeAnimation
                cursor={true}
                sequence={[text2]}
                wrapper="h2"
                repeat={1}
             /> 
             </h1>
 

            <h4 > {text3}</h4>
             {/* {setctarequired(cta)} */}
           {ctarequired?<CTA/>:""}





            <h2 className='connect'>
                <TypeAnimation
                cursor={true}
                sequence={['Connect With Me']}
                wrapper="h2"
                repeat={1}
             /> 
            </h2> 
            <h3>Click Below</h3>

            <HeaderSocial/>
           {/* <div className='me'>
               <img src={ME} alt="me" />
           </div> */}

           <a href="#contact" className='scroll__down'>Scroll Down</a>
        </div>
    </header>
  )
}

export default Header